export const COPILOT_CHOICES = {
	REDEEM_ACCESS_CODE_SUCCESS: `
  Tell the user that the access code has been successfully redeemed.
  Tell them to use the popup above to access their content.
  `,
	REDEEM_ACCESS_CODE_ERROR: `
  CASE 1: Presented Access Code is an OTP.
    Mention the code presented is an OTP.
    A valid Access Code format should be XXX-XXX-XXXXXXXX.
  CASE 2: Presented Access Code is invalid.
    Mention the code is invalid.
    Ask the user to try a different code OR check their email for their Access Codes or Purchase details.
  CASE 3: Presented Access Code is already redeemed by another user.
    Mention the code is already redeemed by another user.
    Ask the user to verify the code they entered. Ask them to check their email for their Access Codes or Purchase details.
  
  Ask if they would like assistance retrieving their purchase details or access codes from their account.
  `,
	ACCESS_CODE_ALREADY_REDEEMED: `
  Inform the user that this access code has already been redeemed by them previously.
  Tell them that they can access their content by clicking on the "Open" button that appears in the chat popup above.
  `,
	USER_CANNOT_FIND_ACCESS_CODE: `
  Ask the user to check their email for their Access Codes or Purchase details.
  Ask if they would like assistance retrieving their purchase details or access codes from their account.
  `,
	ORDER_ID_ERROR: `
  CASE 1: User does not have an Order ID.
  CASE 2: User cannot find an Order ID.
  CASE 3: Invalid Order ID.

  Inform the user that they should reach out to our customer support team for assistance with this issue. Ask if they would like you to provide them with the support contact details.
  `,
	EMAIL_MATCH_SUCCESS: `
  User is using the correct email. Proceed with the action that the user has requested.
  `,
	EMAIL_MATCH_ERROR: `
  User has presented a different email that the one they are logged in to.
  Ask the user to login to the app with the email they provided if they need to check their purchases
  associated with that email account.
  `,
	FETCH_PURCHASES_SUCCESS: `
  DO NOT list the purchases OR access codes.
  Ask the user to use the popup above to select the purchase they want to redeem.
  `,
	FETCH_PURCHASES_ERROR: `
  CASE 1: User does not have any purchases with their account.
  CASE 2: Error occurred while retrieving purchase information.
  
  Suggest that they verify the email address they're currently using.
  Ask the user if they have their Order ID available.
  Explain that purchase details, including the Order ID, were sent to their email at the time of purchase.
  Suggest they search their email inbox for "Order ID" or the name of the product they purchased.
  `,
	RESEND_CODES_SUCCESS: `
  Inform the user that their access codes have been successfully sent to their email address.
  Prompt them to check their inbox for the newly delivered access codes.
  Do specify the email address that the codes were sent to.
  `,
	RESEND_CODES_ERROR: `
  CASE 1: Invalid Order ID.
  CASE 2: Error occurred while resending codes.
  
  Inform the user that they should reach out to our customer support team for assistance with this issue. Ask if they would like you to provide them with the support contact details.
  `,
	CONTACT_SUPPORT: `
  Inform the user that you've prepared an email to {{ appTeamName }} Support Team.
  Let them know their default email client should open with a pre-filled email template.
  If Email Client Doesn't Open:
    Mention them to send an email to {{ appSupportEmail }}.
    DO NOT mention the subject and other details, ask the user to copy those from the above chat popup.
  `,
};
